export const componentsEs = {
  pestAlerts: {
    title: "Alertas Oficiales en Tiempo Real",
    subtitle: "Alertas de organismos fitosanitarios (INIA, SENASA, MAPA, IPPC, EPPO)",
    loadingAlerts: "Cargando alertas fitosanitarias...",
    noActiveAlerts: "No hay alertas activas para tu ubicación y cultivo",
    newAlert: "🚨 Nueva Alerta Fitosanitaria",
    affectedCrops: "Cultivos afectados:",
    viewSource: "Ver fuente oficial",
    realtimeNote: "💡 Las alertas se actualizan automáticamente en tiempo real usando Supabase Realtime",
    errorLoading: "No se pudieron cargar las alertas"
  },
  changePassword: {
    title: "Cambiar Contraseña",
    description: "Ingresa tu nueva contraseña. Debe tener al menos 6 caracteres.",
    newPassword: "Nueva Contraseña",
    confirmPassword: "Confirmar Nueva Contraseña",
    minChars: "Mínimo 6 caracteres",
    repeatPassword: "Repite la contraseña",
    cancel: "Cancelar",
    updating: "Actualizando...",
    changeButton: "Cambiar Contraseña",
    passwordUpdated: "Contraseña actualizada",
    passwordUpdatedDesc: "Tu contraseña ha sido cambiada exitosamente",
    minLengthError: "La nueva contraseña debe tener al menos 6 caracteres",
    mismatchError: "Las contraseñas no coinciden",
    updateError: "No se pudo cambiar la contraseña"
  },
  setPassword: {
    title: "Establece tu contraseña",
    description: "Crea una contraseña para poder acceder a tu cuenta en el futuro",
    newPasswordLabel: "Nueva contraseña",
    placeholder: "Ingresa tu nueva contraseña",
    mustHave: "La contraseña debe tener:",
    min8Chars: "Al menos 8 caracteres",
    oneUppercase: "Al menos una mayúscula",
    oneLowercase: "Al menos una minúscula",
    oneNumber: "Al menos un número",
    confirmLabel: "Confirmar contraseña",
    confirmPlaceholder: "Repite tu contraseña",
    setButton: "Establecer Contraseña",
    settingButton: "Estableciendo...",
    checkingSession: "Verificando sesión...",
    successTitle: "¡Contraseña establecida!",
    successDesc: "Ya puedes acceder a la plataforma con tu email y contraseña.",
    errorSet: "No se pudo establecer la contraseña",
    validationMin8: "La contraseña debe tener al menos 8 caracteres",
    validationUppercase: "Debe contener al menos una mayúscula",
    validationLowercase: "Debe contener al menos una minúscula",
    validationNumber: "Debe contener al menos un número",
    validationMismatch: "Las contraseñas no coinciden"
  },
  pac: {
    loadingPac: "Cargando datos PAC...",
    title: "Datos MAPA — Cuaderno Digital Agrícola",
    subtitle: "Real Decreto 1054/2022 — Campos obligatorios para inspección PAC",
    compliant: "✓ Conforme",
    pendingFields: "{{count}} campos pendientes",
    ropoSection: "Aplicador Fitosanitario (ROPO)",
    ropoNumber: "Nº ROPO del Aplicador *",
    ropoExpiry: "Fecha Caducidad ROPO",
    prescribedBy: "Tratamiento prescrito por asesor fitosanitario",
    productInfo: "Información del Producto",
    productRegNumber: "Nº Registro Producto (MAPA) *",
    activeSubstance: "Sustancia Activa *",
    dosePerHectare: "Dosis por Hectárea (kg o L) *",
    safetyPeriod: "Plazo de Seguridad (días) *",
    applicationDetails: "Detalles de Aplicación",
    applicationMethod: "Método de Aplicación *",
    applicationEquipment: "Equipo de Aplicación",
    select: "Seleccionar...",
    weatherConditions: "Condiciones Meteorológicas",
    windSpeed: "Velocidad del Viento (km/h)",
    temperature: "Temperatura (°C)",
    humidity: "Humedad (%)",
    treatedArea: "Superficie Tratada (ha) *",
    justification: "Justificación del Tratamiento *",
    saving: "Guardando...",
    saveButton: "Guardar Datos PAC",
    allFieldsComplete: "Todos los campos obligatorios MAPA completados",
    pendingFieldsCount: "{{count}} campo(s) pendiente(s)"
  },
  machinery: {
    selectParcelPlaceholder: "Seleccionar parcela",
    selectBrandPlaceholder: "Seleccionar marca"
  },
  worldCereal: {
    selectParcel: "Seleccionar Parcela",
    loadingParcels: "Cargando parcelas...",
    selectParcelOrManual: "Selecciona una parcela o ingresa manualmente",
    enterManually: "✏️ Ingresar manualmente",
    myParcels: "MIS PARCELAS",
    noParcels: "No tienes parcelas registradas.",
    addParcel: "Añade una parcela",
    orEnterManually: "o ingresa los datos manualmente."
  },
  satelliteView: {
    imageUpdated: "Imagen actualizada",
    imageUpdatedDesc: "Nueva imagen con paletas oficiales Copernicus",
    updating: "Actualizando...",
    updateButton: "Actualizar",
    eoUpdated: "Datos EO actualizados",
    eoUpdatedDesc: "Imagen satelital estilo EO Browser actualizada",
    updateError: "Error de Actualización",
    updateErrorDesc: "Error actualizando imagen EO Browser."
  },
  batchExport: {
    exportComplete: "Exportación completada",
    exportCompleteDesc: "{{success}} imágenes exportadas exitosamente",
    failedSuffix: ", {{failed}} fallidas",
    exportError: "No se pudo exportar ninguna imagen",
    batchError: "Error durante la exportación por lotes"
  },
  irrigationReports: {
    generateFirst: "Genera tu primer informe",
    selectParcelAndPeriod: "Selecciona una parcela y período arriba para generar datos de riego científicos",
    dataIncludes: "Los datos incluyen cálculos FAO-56, programación óptima, análisis económico y recomendaciones basadas en IA",
    title: "Informe de decisión de riego",
    subtitle: "Genera un resumen profesional a partir de recomendaciones de riego guardadas, cálculos FAO-56 y registros satelitales/climáticos disponibles.",
    configuration: "Configuración del informe",
    configurationDesc: "Selecciona parcela y período para generar datos de riego",
    parcel: "Parcela",
    selectParcel: "Seleccionar parcela",
    period: "Período",
    periodDaily: "Diario (1 día)",
    periodWeekly: "Semanal (7 días)",
    periodMonthly: "Mensual (30 días)",
    generate: "Generar informe",
    generating: "Generando...",
    preview: "Vista previa",
    exportData: "Exportar datos",
    executiveSummary: "Resumen ejecutivo",
    dailyRequirement: "Demanda hídrica de referencia del cultivo",
    
    waterStress: "Estrés hídrico",
    currentNdvi: "NDVI actual",
    fao56Title: "Cálculos FAO-56",
    method: "Método",
    irrigationSchedule: "Programación de riego",
    optimalHours: "Horarios óptimos",
    frequency: "Frecuencia",
    durationPerSession: "Duración por sesión",
    hour: "hora",
    hours: "horas",
    or: "o",
    alerts: "Alertas",
    priorityRecommendations: "Recomendaciones prioritarias",
    dataAvailability: "Disponibilidad de datos",
    et0Points: "Puntos de datos ET0",
    ndviPoints: "Puntos de datos NDVI",
    sufficientData: "Datos suficientes",
    yes: "Sí",
    no: "No",
    noDataTitle: "Sin datos de informe",
    noDataDesc: "Aún no hay datos de informe de riego para esta parcela y período. Ejecuta primero el Optimizador de Riego o selecciona un período con registros FAO-56/climáticos existentes.",
    missingFields: "Datos faltantes",
    dataLimitedNotice: "Informe generado a partir de la última recomendación de riego guardada. Algunos campos FAO-56 o satelitales no están disponibles para este período.",
    sourceSavedRec: "Informe generado a partir de la última recomendación de riego guardada.",
    sourceDailyRecords: "Informe generado a partir de registros diarios de ET0/NDVI.",
    dataLimitedDetail: "Datos limitados: no hay registros diarios de ET0 y/o serie NDVI disponibles para este período.",
    statusPanelTitle: "Estado del informe",
    reportSource: "Fuente del informe",
    dataStatus: "Estado de datos",
    weatherSource: "Fuente meteorológica",
    satelliteSource: "Fuente satelital",
    savedRecommendation: "Recomendación guardada",
    dailyEt0Series: "Serie diaria ET0",
    ndviRecord: "Registro NDVI",
    available: "Disponible",
    notAvailable: "No disponible",
    waterStressMissing: "No disponible — no se encontró registro NDVI/NDWI de estrés hídrico para este período.",
    ndviMissing: "No disponible — no se encontró registro NDVI Sentinel-2 guardado para este período.",
    recommendationFromSaved: "Informe generado a partir de la última recomendación de riego guardada. Las recomendaciones prioritarias adicionales requieren series diarias de ET0 y datos satelitales.",
    executiveRecommendation: "Recomendación ejecutiva",
    referenceDemandTitle: "Demanda hídrica de referencia del cultivo (ETc)",
    referenceDemandDisclaimer: "Es evapotranspiración del cultivo modelada, no una cantidad de riego a aplicar. Todavía no existe un contrato canónico revisado de objetivo de aplicación de riego.",
    legacyRecommendationTitle: "Recomendación de riego heredada",
    legacyRecommendationNote: "Existe una recomendación de riego heredada histórica para esta parcela. Se conserva solo como auditoría y no es evidencia de decisión actual.",
    
    partialDataDisclaimer: "Esta recomendación se basa en el resultado de riego guardado y debe validarse con condiciones de campo.",
    unitConversions: "Conversiones de unidades",
    perDay: "L/día",
    cubicPerDay: "m³/día",
    perHaPerDay: "L/ha/día",
    mmPerDay: "mm/día equivalente",
    fao56Components: "Componentes FAO-56",
    complete: "Completo",
    partial: "Parcial",
    missing: "Faltante",
    confidence: "Confianza del informe",
    confidenceHigh: "Alta",
    confidenceMedium: "Media",
    confidenceLow: "Baja",
    confidenceLimited: "Datos limitados",
    howToCompleteTitle: "Cómo completar este informe",
    howToCompleteBody: "Para completar NDVI y estrés hídrico, ejecuta Satellite Intelligence → Ver imágenes o Generar histórico NDVI para esta parcela y período. Para completar los registros diarios de ET0, ejecuta el Optimizador de Riego para la parcela seleccionada y guarda la recomendación; las series diarias de ET0/ETc/Kc se completan después mediante el pipeline FAO-56 dual-Kc.",
    metricSourcesTitle: "Fuentes de métricas",
    metricSourceDailyRequirement: "Requerimiento diario: calculado a partir de ETc FAO-56 y superficie de la parcela.",
    metricSourceEt0: "ET0: cálculo FAO-56 a partir de datos meteorológicos.",
    metricSourceEtc: "ETc: ET0 × Kc.",
    metricSourceKc: "Kc: coeficiente de cultivo usado por el modelo de riego.",
    metricSourceNdvi: "NDVI actual: registro NDVI Sentinel-2 guardado.",
    metricSourceWaterStress: "Estrés hídrico: derivado de {{source}}.",
    metricSourceWaterStressEstimated: "Estrés hídrico: estimado — sin registro real NDWI/NDMI persistido (datos limitados).",
    metricSourceWaterIndex: "Índice hídrico satelital: observación descriptiva {{source}} — no es estrés hídrico de la zona radicular.",
    metricSourceWaterIndexMissing: "Índice hídrico satelital: no disponible — sin registro NDWI/NDMI persistido para este período.",
    waterIndexTitle: "Índice hídrico satelital (NDWI/NDMI)",
    waterIndexDisclaimer: "Contexto descriptivo del índice hídrico satelital — no es estrés hídrico de la zona radicular.",
    waterIndexMissing: "No disponible — sin registro NDWI/NDMI persistido para este período.",
    applicationTargetTitle: "Objetivo de aplicación de riego",
    applicationTargetUnavailable: "No hay una cantidad de riego disponible: no existe un contrato canónico revisado de objetivo de aplicación de riego.",
    reviewCanonicalWaterState: "Revisa la evidencia canónica actual del estado hídrico.",
    waterStressEstimatedBadge: "Estimado",
    waterStressObservedBadge: "Observado por satélite",
    weatherRecords: "Registros meteorológicos",
    exportNotAvailable: "La exportación aún no está disponible para este informe.",
    exportOptions: "Opciones de exportación",
    exportOptionsDesc: "Descarga los datos en el formato que prefieras",
    forApisScripts: "Para APIs y scripts",
    forSpreadsheets: "Para Excel/Google Sheets",
    sendByEmail: "Enviar por correo",
    useFor: "Usa estos datos para:",
    useForPdf: "Crear informes PDF profesionales en Canva, InDesign, etc.",
    useForExcel: "Importar a Excel para análisis personalizado",
    useForBi: "Integrar con Google Data Studio o Power BI",
    useForAutomation: "Automatizar con Zapier, Make o scripts propios",
    useForClients: "Enviar a clientes con tu propio branding",
    includedData: "Datos incluidos:",
    includedFao56: "Cálculos FAO-56 científicos",
    includedEconomic: "Análisis económico completo",
    includedSchedule: "Programación óptima de riego",
    includedConditions: "Condiciones actuales (NDVI, NDWI)",
    includedForecast: "Pronóstico 7 días",
    includedHistorical: "Históricos 30 días",
    includedAi: "Recomendaciones IA",
    includedRiskAlerts: "Alertas de riesgo"
  },
  canvasMasked: {
    fullSatelliteView: "Vista Satelital Completa",
    couldNotGenerateMask: "(No se pudo generar máscara de parcela)",
    fullViewShown: "Vista satelital mostrada",
    fullViewShownDesc: "Se muestra la imagen completa porque no se pudo generar la máscara de la parcela"
  },
  issuePolicy: {
    parcel: "Parcela",
    selectParcel: "Selecciona parcela",
    noParcels: "No hay parcelas"
  },
  aiModel: {
    loading: "Cargando..."
  },
  regionalIntelligence: {
    status: "Estado",
    noStoredNdvi: "No hay una serie histórica NDVI guardada para esta parcela. Puede existir imagen Sentinel-2 reciente, pero aún no se ha guardado como registro histórico NDVI.",
    openSatelliteImages: "Abrir Imágenes Satélite para guardar NDVI",
    recordsStored: "Registros NDVI guardados: {{count}} / 4 requeridos. Se necesita al menos un registro NDVI actual y 3 registros anteriores para calcular la anomalía.",
    openSatelliteImagesMore: "Abrir imágenes satelitales para guardar más registros NDVI"
  },
  leafletSentinel: {
    unknownError: "Error desconocido",
    errorLoading: "Error cargando {{type}}: {{msg}}",
    checkConnection: "Verifica tu conexión e intenta nuevamente",
    couldNotCreateCanvas: "No se pudo crear contexto de canvas",
    ndviNotLoaded: "Imagen NDVI no está completamente cargada",
    zonesGeneratedNotSaved: "Zonas generadas pero no guardadas en DB: ",
    errorSavingZones: "Error al guardar zonas:"
  }
};
